import React from 'react';
import { StyledIconButton } from './CustomIconButton.styles';
import { IconDefinition } from '@amzn/storm-ui-icons';

interface CustomIconButtonProps {
  icon: IconDefinition;
  label: string;
  backgroundColor?: string;
  handleOnClickCb?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
}

export const CustomIconButton: React.FC<CustomIconButtonProps> = ({
  icon,
  label,
  backgroundColor,
  handleOnClickCb,
  disabled = false,
}) => {
  return (
    <StyledIconButton
      icon={icon}
      label={label}
      backgroundColor={backgroundColor}
      onClick={handleOnClickCb}
      disabled={disabled}
      variant="primary"
      type="button"
    />
  );
};
